export const mediaContentCreator = {
  id: 'media-content-creator',
  version: 2,
  renderer: 'enterprise',
  name: 'Media & Content Creator',
  layout: 'sidebar-left',
  theme: 'modern-teal',
  density: 'comfortable',
  persona: ['creative'],
  atsLevel: 'C',
  scoreWeights: {
    ats: 15,
    visual: 55,
    executive: 10,
    student: 20
  },
  metadata: {
    industry: ['Social Media', 'Content Creation', 'Digital Video Production'],
    companies: ['YouTube', 'TikTok', 'ByteDance', 'Buzzfeed', 'Spotify', 'Meta social media', 'Red Bull Media'],
    ats: ['Lever', 'Greenhouse'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: true,
    icons: true,
    columns: 2,
    experienceLevel: ['Entry-level', 'Mid-level', 'Senior'],
    recommendedFor: ['Content Creators', 'Social Media Managers', 'Video Editors', 'Influencer Marketers'],
    avoidFor: ['Investment Bankers', 'Academic Researchers', 'Corporate Lawyers'],
    dna: ['Visual-Media', 'Teal-Accents', 'Sidebar-Left-Magazine', 'Social-Native', 'Sans-Serif'],
    metrics: {
      readingDifficulty: 86,
      scanningSpeed: 88,
      visualAppeal: 97
    },
    hiringManager: {
      firstImpression: "Vibrant, social-media native video and content production specialist",
      scanningStyle: "F-Pattern scanning focusing on social follower count, campaign views, and tools stack",
      preferredStructure: "Summary and projects in main body; education, skills, and languages in sidebar",
      dislikes: ["Dull black-and-white printouts", "No links to social profiles/Youtube channels", "Dry corporate text descriptions"]
    },
    strategy: {
      goal: "Hook digital agency and media brand recruiters with a bold left-sidebar visual design",
      focus: "Social metrics (views, subscribers, CTR), video editing tool mastery (Premiere Pro, CapCut)",
      avoid: ["Traditional serif layouts", "Dense text block formatting"]
    },
    psychology: {
      coreTraits: ["Creativity", "Modernity", "Social media engagement", "Energy"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: false,
      sidebar: true
    },
    aiPrompt: {
      writingStyle: "Highlight audience growth, viral content metrics (views, click-through-rates), and editing speed. Use engaging branding adjectives.",
      rewriteStyle: "Creative, engaging, audience-focused"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'sidebar-left': {
      component: 'sidebar-left',
      slots: {
        header: ['personal-info'],
        sidebar: ['skills', 'languages', 'education'],
        main: ['summary', 'projects', 'experience']
      },
      overrides: {
        '--layout-sidebar-width': '197px',
        '--layout-column-gap': '20px'
      }
    }
  },
  sectionOrder: ['personal-info', 'summary', 'projects', 'experience', 'skills', 'languages', 'education'],
  components: {
    header: 'personal-info',
    sidebar: ['skills', 'languages', 'education'],
    main: ['summary', 'projects', 'experience'],
  },
  capabilities: {
    photo: true,
    icons: true,
    multiColumn: true,
    colorAccent: true,
    atsOptimized: false,
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'none',
    '--heading-weight': '600',
    '--border-thickness-heading': '3px',
    '--bullet-style': 'square',
    '--spacing-section-mb': '20px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px'
  }
};
export default mediaContentCreator;
